import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { notificationIntegration } from '@/lib/api/client.js';
import { navigateFromNotification } from '@/lib/notifications/navigate-from-notification';

export function useNotificationNavigation() {
  const navigate = useNavigate();

  const handleNotificationClick = useCallback(
    (notification) => {
      if (!notification) return false;
      return navigateFromNotification(notification, {
        navigate,
        markAsRead: (id) => notificationIntegration.markAsRead(id),
      });
    },
    [navigate],
  );

  return { handleNotificationClick };
}
